import React from 'react';

const Sidebar = () => {
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <aside className="automation-sidebar">
            <h3 className="sidebar-section-title">Triggers</h3>
            <div className="sidebar-item" onDragStart={(event) => onDragStart(event, 'trigger')} draggable>
                📅 Event Trigger
            </div>

            <h3 className="sidebar-section-title">Actions</h3>
            <div className="sidebar-item" onDragStart={(event) => onDragStart(event, 'whatsapp')} draggable>
                💬 Send WhatsApp
            </div>
            <div className="sidebar-item" onDragStart={(event) => onDragStart(event, 'email')} draggable>
                📧 Send Email
            </div>
            <div className="sidebar-item" onDragStart={(event) => onDragStart(event, 'delay')} draggable>
                ⏳ Delay
            </div>

            <h3 className="sidebar-section-title">Logic</h3>
            <div className="sidebar-item" onDragStart={(event) => onDragStart(event, 'condition')} draggable>
                Condition
            </div>
        </aside>
    );
};

export default Sidebar;
